import { TLeadSubscriptionStatus } from 'models/lead.model'

export const getHasActiveSubscriptionStatus = (
  status: TLeadSubscriptionStatus,
  isVcCohorts?: boolean,
): boolean =>
  status === 'active' ||
  status === 'active_paused' ||
  status === 'active_resuming' ||
  status === 'trial' ||
  status === 'trial_paused' ||
  status === 'dunning' ||
  status === 'trial_cancel_requested' ||
  status === 'active_cancel_requested' ||
  status === 'active_extended' ||
  (!!isVcCohorts && status === 'cancelled')
